export const propInfo = {
  name: {
    saveSuccess: "Nome da propriedade salvo com sucesso",
    successTitle: "Sucesso",
    saveError: "Não foi possível salvar o nome da propriedade",
  },
  capacity: {
    saveSuccess: "Capacidade salva com sucesso",
    saveError: "Não foi possível salvar a capacidade",
  },
  location: {
    loadError: "Não foi possível carregar os detalhes do anúncio.",
    appliedBulk: "Localização aplicada a {count} acomodações vinculadas",
    saveSuccess: "Localização salva com sucesso",
    partialError: "Não foi possível atualizar algumas acomodações",
    savePropertySuccess: "Localização da propriedade salva com sucesso",
    saveError: "Não foi possível salvar a localização da propriedade",
    loading: "Carregando a localização do anúncio…",
    noUnitsTitle: "Este anúncio ainda não tem unidades configuradas.",
    noUnitsText: "Crie pelo menos uma unidade para configurar a localização.",
    bulkNotice: "Esta alteração será aplicada às {count} acomodações vinculadas a {name}.",
  },
  description: {
    saveSuccess: "Descrição salva com sucesso",
    saveError: "Não foi possível salvar a descrição",
    cloneTitleNoun: "descrição",
    cloneItemNoun: "a descrição",
  },
};
